var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Formulas for objective calculations
 */
import { round } from "@popperjs/core/lib/utils/math";
import { HttpClient } from "@/lib/http";
const computeVolumen = (fields) => {
    const { periodo_actual, periodo_anterior, objetivo_porcentaje } = fields;
    const objetivo_cu = periodo_anterior + periodo_anterior * objetivo_porcentaje;
    const cajas_faltantes = Math.max(0, objetivo_cu - periodo_actual);
    const porcentaje_conseguido = objetivo_cu > 0 ? periodo_actual / objetivo_cu : 0;
    return {
        periodo_actual: periodo_actual,
        periodo_anterior: periodo_anterior,
        objetivo_porcentaje,
        objetivo_cu,
        cajas_faltantes,
        porcentaje_conseguido,
    };
};
const computeVolumen2 = (fields) => {
    const { periodo_actual, periodo_anterior, /*objetivo_porcentaje,*/ bp_cu_mes_natural } = fields;
    // Normaliza porcentajes que pueden venir como string "5" para 5% o con coma decimal
    const normalizePercent = (value) => {
        if (value === null || value === undefined)
            return 0;
        const num = typeof value === 'string'
            ? parseFloat(value.replace(',', '.'))
            : Number(value);
        if (Number.isNaN(num))
            return 0;
        return num; // dejamos el valor tal cual; la fórmula divide entre 100 explícitamente
    };
    const propuestaPct = normalizePercent(bp_cu_mes_natural);
    // Fórmula requerida: objetivo_cu = periodo_anterior + periodo_anterior * (propuesta_bp_{mes_natural} / 100)
    const objetivo_cu = periodo_anterior + periodo_anterior * (propuestaPct / 100);
    const cajas_faltantes = Math.max(0, objetivo_cu - periodo_actual);
    const porcentaje_conseguido = objetivo_cu > 0 ? periodo_actual / objetivo_cu : 0;
    return {
        periodo_actual: periodo_actual,
        periodo_anterior: periodo_anterior,
        bp_cu_mes_natural,
        objetivo_cu,
        cajas_faltantes,
        porcentaje_conseguido,
    };
};
const computeClientes = (fields) => {
    const { periodo_actual, periodo_anterior } = fields;
    const objetivo = Math.round(periodo_anterior * 1.01);
    const clientes_faltantes = Math.max(0, objetivo - periodo_actual);
    const porcentaje_conseguido = objetivo > 0 ? periodo_actual / objetivo : 0;
    return {
        periodo_actual: periodo_actual,
        periodo_anterior: periodo_anterior,
        objetivo,
        clientes_faltantes,
        porcentaje_conseguido,
    };
};
const computeRefPromedio = (fields) => {
    const { periodo_actual, periodo_anterior } = fields;
    const porcentaje_conseguido = (periodo_actual > periodo_anterior) ? 1 : 0;
    return {
        periodo_actual: periodo_actual,
        periodo_anterior: periodo_anterior,
        porcentaje_conseguido,
    };
};
const computeGDA = (fields) => {
    return Object.assign({}, fields);
};
const computeTotal = (value) => {
    if (value >= 1.1)
        return 1.1;
    if (value >= 1.0)
        return 1.0;
    if (value >= 0.8)
        return 0.5;
    return 0;
};
const computeGDACompliance = (objective, result) => {
    if (objective === 0)
        return 0;
    const compliance = result / objective;
    if (compliance >= 1.0)
        return 1.0;
    if (compliance >= 0.85)
        return 0.5;
    return 0;
};
const computeProcentajeCumplimientoClientes = (obj_clientes, result_cliente) => {
    if (result_cliente >= obj_clientes)
        return 1;
    return 0;
};
// Cache para los datos de la curva de KPI de North
const northCurvaCache = {};
const fetchNorthCurva = (ano_natural, mes_natural) => __awaiter(void 0, void 0, void 0, function* () {
    const cacheKey = `${ano_natural || 'default'}_${mes_natural || 'default'}`;
    if (northCurvaCache[cacheKey]) {
        return northCurvaCache[cacheKey];
    }
    northCurvaCache[cacheKey] = (() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const params = {};
            if (ano_natural)
                params.ano_natural = ano_natural;
            if (mes_natural)
                params.mes_natural = mes_natural;
            const response = yield HttpClient.get('/webapi/data/north-curva-kpi-ctes', params);
            if ((response === null || response === void 0 ? void 0 : response.data) && Array.isArray(response.data)) {
                return response.data;
            }
        }
        catch (error) {
            console.error('Error fetching north curva data:', error);
            delete northCurvaCache[cacheKey];
        }
        return [];
    }))();
    return northCurvaCache[cacheKey];
});
const computeClientesNorth = (fields) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { periodo_actual, periodo_anterior, objetivo_porcentaje, ano_natural, mes_natural } = fields;
    const objetivo_cf = (_a = fields.objetivo_cf) !== null && _a !== void 0 ? _a : ((periodo_anterior * 1) + ((periodo_anterior * 1) * objetivo_porcentaje / 100));
    const objetivoRedondeado = round(objetivo_cf);
    const cumplimientoVsObjetivo = objetivoRedondeado > 0 ? ((periodo_actual * 1) / objetivoRedondeado) - 1 : 0;
    const porcentaje_cumplimiento = periodo_anterior !== 0 ? ((periodo_actual * 1) / (periodo_anterior * 1)) - 1 : 0;
    let porcentaje_red = 0;
    const consec_vs_objetivo_porcentaje = objetivoRedondeado > 0 ? (periodo_actual / objetivoRedondeado) : 0;
    const rows_curva = yield fetchNorthCurva(ano_natural, mes_natural);
    if (rows_curva && rows_curva.length > 0) {
        // Reglas fijas de Excel (los IF externos)
        if (porcentaje_cumplimiento < -0.02) {
            porcentaje_red = 0;
        }
        else if (porcentaje_cumplimiento > 0.04) {
            porcentaje_red = 1.1;
        }
        else {
            // Parte VLOOKUP (coincidencia aproximada)
            // Ordenar ascendente por cobertura (aunque ya deberían venir ordenados, nos aseguramos en la primera carga o si el cache es compartido)
            // Nota: sort muta el array, pero como es el mismo objeto en cache, se ordena una vez.
            rows_curva.sort((a, b) => a.cobertura - b.cobertura);
            // Buscar el tramo correcto:
            // el mayor valor de cobertura que sea <= al cumplimiento
            const matchingRow = [...rows_curva] // copiamos para no mutar al hacer reverse
                .reverse()
                .find(row => porcentaje_cumplimiento >= row.cobertura);
            if (matchingRow) {
                porcentaje_red = matchingRow.retribucion;
            }
            else {
                // Seguridad por si no encuentra nada
                porcentaje_red = 0;
            }
        }
    }
    return {
        periodo_actual: periodo_actual,
        periodo_anterior: periodo_anterior,
        objetivo_porcentaje,
        consec_vs_objetivo_porcentaje,
        objetivo_cf,
        porcentaje_cumplimiento,
        porcentaje_red,
        retribucion: porcentaje_red,
    };
});
// Cache para los datos de la curva de KPI Fuze de North
const northCurvaFuzeCache = {};
const fetchNorthCurvaFuze = (ano_natural, mes_natural) => __awaiter(void 0, void 0, void 0, function* () {
    const cacheKey = `${ano_natural || 'default'}_${mes_natural || 'default'}`;
    if (northCurvaFuzeCache[cacheKey]) {
        return northCurvaFuzeCache[cacheKey];
    }
    northCurvaFuzeCache[cacheKey] = (() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const params = {};
            if (ano_natural)
                params.ano_natural = ano_natural;
            if (mes_natural)
                params.mes_natural = mes_natural;
            const response = yield HttpClient.get('/webapi/data/north-curva-kpi-fuzes', params);
            if ((response === null || response === void 0 ? void 0 : response.data) && Array.isArray(response.data)) {
                return response.data;
            }
        }
        catch (error) {
            console.error('Error fetching north curva fuze data:', error);
            delete northCurvaFuzeCache[cacheKey];
        }
        return [];
    }))();
    return northCurvaFuzeCache[cacheKey];
});
const computeClientesNorthFuze = (fields) => __awaiter(void 0, void 0, void 0, function* () {
    const { periodo_actual, periodo_anterior, ano_natural, mes_natural } = fields;
    const porcentaje_cumplimiento = periodo_anterior !== 0 ? ((periodo_actual * 1) / (periodo_anterior * 1)) - 1 : 0;
    let porcentaje_red = 0;
    const rows_curva = yield fetchNorthCurvaFuze(ano_natural, mes_natural);
    if (rows_curva && rows_curva.length > 0) {
        rows_curva.sort((a, b) => a.cobertura - b.cobertura);
        const minCobertura = rows_curva[0].cobertura;
        const maxRow = rows_curva[rows_curva.length - 1];
        if (porcentaje_cumplimiento < minCobertura) {
            porcentaje_red = 0;
        }
        else if (porcentaje_cumplimiento > maxRow.cobertura) {
            porcentaje_red = maxRow.retribucion;
        }
        else {
            const matchingRow = [...rows_curva]
                .reverse()
                .find(row => porcentaje_cumplimiento >= row.cobertura);
            porcentaje_red = matchingRow ? matchingRow.retribucion : 0;
        }
    }
    return {
        periodo_actual,
        periodo_anterior,
        porcentaje_cumplimiento,
        porcentaje_red,
        retribucion: porcentaje_red,
    };
});
const computeVolumenNorth = (fields) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { periodo_actual, periodo_anterior, objetivo_porcentaje, ano_natural, mes_natural } = fields;
    const objetivo_cf = (_a = fields.objetivo_cf) !== null && _a !== void 0 ? _a : ((periodo_anterior * 1) + ((periodo_anterior * 1) * objetivo_porcentaje / 100));
    const consec_vs_objetivo_porcentaje = objetivo_cf > 0 ? (periodo_actual / round(objetivo_cf)) : 0;
    const porcentaje_cumplimiento = objetivo_cf > 0 ? consec_vs_objetivo_porcentaje : 0;
    let porcentaje_red = 0;
    // =IF(porcentaje_cumplimiento>1;1;IF(porcentaje_cumplimiento<0,86;0;porcentaje_cumplimiento))
    if (porcentaje_cumplimiento > 1) {
        porcentaje_red = 1;
    }
    else if (porcentaje_cumplimiento < 0.86) {
        porcentaje_red = 0;
    }
    else {
        porcentaje_red = porcentaje_cumplimiento;
    }
    return {
        periodo_actual: periodo_actual,
        periodo_anterior: periodo_anterior,
        objetivo_porcentaje,
        objetivo_cf,
        consec_vs_objetivo_porcentaje,
        porcentaje_cumplimiento,
        porcentaje_red,
        retribucion: porcentaje_red,
    };
});
const computeMediaConsecucionObjetivos = (fields) => {
    const { clientes_aact, clientes_aant } = fields;
    const porcentaje = clientes_aant > 0 ? clientes_aact / clientes_aant : 0;
    return {
        clientes_aact: clientes_aact,
        clientes_aant: clientes_aant,
        porcentaje_conseguido: porcentaje,
    };
};
const computeComprad = (fields) => {
    const { vol_aact, vol_aant } = fields;
    const porcentaje = vol_aant > 0 ? vol_aact / vol_aant : 0;
    return {
        vol_aact: vol_aact,
        vol_aant: vol_aant,
        porcentaje_conseguido: porcentaje,
    };
};
const computeCanariasGrowthByPercent = (fields) => {
    const { periodo_actual, periodo_anterior, objetivo_porcentaje } = fields;
    const proposalText = String(objetivo_porcentaje !== null && objetivo_porcentaje !== void 0 ? objetivo_porcentaje : "").trim();
    const proposalValue = parseFloat(proposalText.replace("%", "").replace(",", ".")) || 0;
    const ant = Number(periodo_anterior);
    const act = Number(periodo_actual);
    const objetivo_cu = proposalText.includes("%")
        ? ant + (ant * (proposalValue / 100))
        : ant + proposalValue;
    const cajas_faltantes = objetivo_cu - act;
    const porcentaje_conseguido = act > objetivo_cu ? 0.25
        : act / objetivo_cu > 0.8 ? act / objetivo_cu * 0.25
            : 0;
    return {
        periodo_actual,
        periodo_anterior,
        objetivo_porcentaje,
        objetivo_cu,
        cajas_faltantes,
        porcentaje_conseguido,
    };
};
const computeCanariasClientesCompradores = (fields) => {
    const { periodo_actual, periodo_anterior, objetivo_porcentaje } = fields;
    const proposalText = String(objetivo_porcentaje !== null && objetivo_porcentaje !== void 0 ? objetivo_porcentaje : "").trim();
    const proposalValue = parseFloat(proposalText.replace("%", "").replace(",", ".")) || 0;
    const objetivo = proposalText.includes("%")
        ? Number(periodo_anterior) + Number(periodo_anterior) * (proposalValue / 100)
        : Number(periodo_anterior) + proposalValue;
    const clientes_faltantes = objetivo - periodo_actual;
    const porcentaje_conseguido = periodo_actual > objetivo ? 0.25
        : periodo_actual / objetivo > 0.8 ? periodo_actual / objetivo * 0.25
            : 0;
    return {
        periodo_actual,
        periodo_anterior,
        objetivo,
        clientes_faltantes,
        porcentaje_conseguido,
    };
};
const computeCanon = (fields) => {
    const { periodo_actual, periodo_anterior } = fields;
    return {
        periodo_actual,
        periodo_anterior,
    };
};
const computeCenterMadridYoY = (fields) => {
    const { periodo_actual, periodo_anterior } = fields;
    return {
        periodo_actual,
        periodo_anterior,
        "%": periodo_anterior !== 0 ? (periodo_actual / periodo_anterior) - 1 : 0,
    };
};
const computeCenterMadridRefPromedio = (fields) => {
    const { periodo_actual, periodo_anterior } = fields;
    return {
        periodo_actual,
        periodo_anterior,
        porcentaje_crecimiento: periodo_anterior !== 0 ? ((periodo_actual / periodo_anterior) - 1) * 100 : 0,
    };
};
const computeCenterMadridSurtido = (fields) => {
    const { fde_por_refs_obj_aact, fde_por_refs_obj_aant } = fields;
    return Object.assign(Object.assign({}, fields), { diferencia_fde: fde_por_refs_obj_aact - fde_por_refs_obj_aant });
};
const computeCajasRegalo = (fields) => {
    const { venta_bruta_aact, venta_bruta_cajas_regalo } = fields;
    return {
        venta_bruta_aact,
        venta_bruta_cajas_regalo,
        porcentaje_conseguido: venta_bruta_aact !== 0 ? venta_bruta_cajas_regalo / venta_bruta_aact : 0,
    };
};
const computeCajasRegaloResultFormula = (fields) => {
    const { periodo_actual, min, max } = fields;
    if (min == null || max == null) {
        return { periodo_actual, min, max, result: 0 };
    }
    let result;
    if (periodo_actual <= min) {
        result = 1;
    }
    else if (periodo_actual >= max) {
        result = 0;
    }
    else {
        result = (max - periodo_actual) / (max - min);
    }
    return { periodo_actual, min, max, result };
};
const computeVolumenCatalunya = (fields) => {
    const { periodo_actual, periodo_anterior, objetivo_porcentaje } = fields;
    const objetivo_cu = Math.round(1 * periodo_anterior + (periodo_anterior * objetivo_porcentaje));
    const porcentaje_conseguido = objetivo_cu > 0 ? ((1 * periodo_actual) / objetivo_cu) : 0;
    return {
        periodo_actual,
        periodo_anterior,
        objetivo_porcentaje,
        objetivo_cu,
        porcentaje_conseguido,
    };
};
const computeClientesCatalunya = (fields) => {
    const { periodo_actual, periodo_anterior, objetivo_porcentaje } = fields;
    const objetivo_cu = Math.ceil(1 * periodo_anterior + (periodo_anterior * objetivo_porcentaje / 100));
    const porcentaje_conseguido = objetivo_cu > 0 ? (periodo_actual / objetivo_cu) : 0;
    return {
        periodo_actual,
        periodo_anterior,
        objetivo_porcentaje,
        objetivo_cu,
        porcentaje_conseguido,
    };
};
const computeCilindrosRefrescosVrCatalunya = (fields) => {
    const { periodo_actual, periodo_anterior, objetivo_porcentaje } = fields;
    const objetivo_cu = Math.ceil(1 * periodo_anterior + (periodo_anterior * objetivo_porcentaje));
    const porcentaje_conseguido = objetivo_cu > 0 ? (periodo_actual / objetivo_cu) : 0;
    return {
        periodo_actual,
        periodo_anterior,
        objetivo_porcentaje,
        objetivo_cu,
        porcentaje_conseguido,
    };
};
const computeClientesCatalunyaRPV = (fields) => {
    const { periodo_actual, periodo_anterior } = fields;
    const clientes_obj = Number(periodo_anterior) + 5;
    const porcentaje_conseguido = clientes_obj > 0 ? (periodo_actual / clientes_obj) : 0;
    return {
        periodo_actual,
        periodo_anterior,
        clientes_obj,
        porcentaje_conseguido,
    };
};
const computeRefPromedioCataluntaRPV = (fields) => {
    const { periodo_actual, periodo_anterior, objetivo_porcentaje } = fields;
    const prom_ref = periodo_anterior + periodo_anterior * objetivo_porcentaje;
    const porcentaje_conseguido = prom_ref > 0 ? periodo_actual / prom_ref : 0;
    return {
        periodo_actual,
        periodo_anterior,
        objetivo_porcentaje,
        prom_ref,
        porcentaje_conseguido,
    };
};
const computeCumplimiento = (fields) => {
    const { rtdo, obj } = fields;
    const diff = obj - rtdo;
    const percent = obj > 0 ? rtdo / obj : 0;
    return {
        rtdo,
        obj,
        diff,
        percent
    };
};
const computeClientesIncClientes = (fields) => {
    const { periodo_actual, periodo_anterior } = fields;
    const inc_clientes = periodo_actual - periodo_anterior;
    return {
        periodo_actual,
        periodo_anterior,
        inc_clientes
    };
};
const computeSouthVolumen = (fields) => {
    var _a, _b, _c, _d;
    const actual = Number((_b = (_a = fields['vol_esp_aact']) !== null && _a !== void 0 ? _a : fields['vol_esp_1_aact']) !== null && _b !== void 0 ? _b : 0);
    const previous = Number((_d = (_c = fields['vol_esp_aant']) !== null && _c !== void 0 ? _c : fields['vol_esp_1_aant']) !== null && _d !== void 0 ? _d : 0);
    const rawProposal = fields['propuesta_incremento_volumen'];
    const proposal = rawProposal != null && rawProposal !== ''
        ? parseFloat(String(rawProposal).replace(',', '.'))
        : null;
    const objetivo_cu = proposal !== null && !isNaN(proposal) ? previous * (1 + proposal / 100) : null;
    const cajas_faltantes = objetivo_cu !== null ? Math.max(0, objetivo_cu - actual) : null;
    const porcentaje_conseguido = objetivo_cu !== null && objetivo_cu > 0 ? actual / objetivo_cu : null;
    return Object.assign(Object.assign(Object.assign(Object.assign({}, fields), (objetivo_cu !== null ? { objetivo_cu } : {})), (cajas_faltantes !== null ? { cajas_faltantes } : {})), (porcentaje_conseguido !== null ? { porcentaje_conseguido } : {}));
};
const computeSouthClientes = (fields) => {
    var _a, _b, _c, _d;
    const actual = Number((_b = (_a = fields['clientes_esp_1_aact']) !== null && _a !== void 0 ? _a : fields['clientes_esp_aact']) !== null && _b !== void 0 ? _b : 0);
    const previous = Number((_d = (_c = fields['clientes_esp_1_aant']) !== null && _c !== void 0 ? _c : fields['clientes_esp_aant']) !== null && _d !== void 0 ? _d : 0);
    const rawProposal = fields['propuesta_incremento_clientes'];
    const proposal = rawProposal != null && rawProposal !== ''
        ? parseFloat(String(rawProposal).replace(',', '.'))
        : null;
    const objetivo = proposal !== null && !isNaN(proposal) ? previous * (1 + proposal / 100) : null;
    const clientes_faltantes = objetivo !== null ? Math.max(0, objetivo - actual) : null;
    const porcentaje_conseguido = objetivo !== null && objetivo > 0 ? actual / objetivo : null;
    return Object.assign(Object.assign(Object.assign(Object.assign({}, fields), (objetivo !== null ? { objetivo } : {})), (clientes_faltantes !== null ? { clientes_faltantes } : {})), (porcentaje_conseguido !== null ? { porcentaje_conseguido } : {}));
};
const computeSouthDn = (fields) => {
    var _a, _b, _c, _d, _e;
    const totalPrevious = Number((_a = fields['clientes_aant']) !== null && _a !== void 0 ? _a : 0);
    const buyersPrevious = Number((_c = (_b = fields['clientes_esp_aant']) !== null && _b !== void 0 ? _b : fields['clientes_esp_1_aant']) !== null && _c !== void 0 ? _c : 0);
    const buyersActual = Number((_e = (_d = fields['clientes_esp_aact']) !== null && _d !== void 0 ? _d : fields['clientes_esp_1_aact']) !== null && _e !== void 0 ? _e : 0);
    const rawProposal = fields['propuesta_incremento_dn'];
    const proposal = rawProposal != null && rawProposal !== ''
        ? parseFloat(String(rawProposal).replace(',', '.'))
        : null;
    const ddnn_anterior = totalPrevious > 0 ? buyersPrevious / totalPrevious : 0;
    const ddnn_objetivo = proposal !== null && !isNaN(proposal) ? ddnn_anterior + (proposal / 100) : null;
    const objetivo = ddnn_objetivo !== null ? totalPrevious * ddnn_objetivo : null;
    const clientes_faltantes = objetivo !== null ? Math.max(0, objetivo - buyersActual) : null;
    const porcentaje_conseguido = objetivo !== null && objetivo > 0 ? buyersActual / objetivo : null;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, fields), { ddnn_anterior: Math.round(ddnn_anterior * 10000) / 10000 }), (ddnn_objetivo !== null ? { ddnn_objetivo: Math.round(ddnn_objetivo * 10000) / 10000 } : {})), (objetivo !== null ? { objetivo } : {})), (clientes_faltantes !== null ? { clientes_faltantes } : {})), (porcentaje_conseguido !== null ? { porcentaje_conseguido } : {}));
};
;
;
const computeMadridResult = (fields) => {
    const { periodo_actual, min, max } = fields;
    let result = 0;
    if (periodo_actual < min) {
        result = 0;
    }
    else if (periodo_actual >= max) {
        result = 1;
    }
    else {
        result = (periodo_actual - min) / (max - min);
    }
    return {
        periodo_actual,
        min,
        max,
        result
    };
};
const computeVolumenAcumPct = (f) => {
    const divisor = f.vol_acum_aant * (1 + f.bp_acum / 100);
    const pct = divisor !== 0 ? (f.vol_acum_aact / divisor) * 100 : 0;
    return Number.isFinite(pct) ? pct : 0;
};
const computeClientesPct = (f) => {
    const divisor = f.clientes_mes_anterior * 1.01;
    const pct = divisor !== 0 ? (f.clientes_mes_actual / divisor) * 100 : 0;
    return Number.isFinite(pct) ? pct : 0;
};
const computeGdaGroupPct = (f) => {
    const pct = f.obj !== 0 ? (f.rtdo / f.obj) * 100 : 0;
    return Number.isFinite(pct) ? pct : 0;
};
const computeBalearesClientesIncrement = (fields) => {
    const { periodo_anterior, periodo_actual, objetivo_absoluto } = fields;
    if (periodo_anterior == null || periodo_anterior === '' ||
        objetivo_absoluto == null || objetivo_absoluto === '') {
        return {
            periodo_anterior,
            periodo_actual,
            objetivo: null,
            porcentaje_conseguido: null,
            clientes_faltantes: null,
        };
    }
    const objetivo = Number(periodo_anterior) + Number(objetivo_absoluto);
    const porcentaje_conseguido = objetivo > 0 && periodo_actual != null
        ? Number(periodo_actual) / objetivo
        : null;
    const clientes_faltantes = periodo_actual != null
        ? Math.max(0, objetivo - Number(periodo_actual))
        : null;
    return { periodo_anterior, periodo_actual, objetivo, porcentaje_conseguido, clientes_faltantes };
};
const computeBalearesVariableKpi = (fields) => {
    const { result_field, objetivo_target } = fields;
    if (objetivo_target == null || objetivo_target === '' || Number(objetivo_target) === 0) {
        return { result_field, objetivo_target, objetivo: null, porcentaje_conseguido: null };
    }
    const objetivo = Number(objetivo_target);
    const porcentaje_conseguido = result_field != null
        ? Number(result_field) / objetivo
        : null;
    return { result_field, objetivo_target, objetivo, porcentaje_conseguido };
};
export const FORMULAS = {
    passthrough: (fields) => fields,
    volumen: computeVolumen,
    volumen2: computeVolumen2,
    volumen_acumulado: computeVolumen,
    clientes: computeClientes,
    ref_promedio: computeRefPromedio,
    gda: computeGDA,
    total: computeTotal,
    gda_compliance: computeGDACompliance,
    porcentaje_cumplimiento_clientes: computeProcentajeCumplimientoClientes,
    clientes_north: computeClientesNorth,
    clientes_north_fuze: computeClientesNorthFuze,
    volumen_north: computeVolumenNorth,
    canon: computeCanon,
    media_consecucion_objetivos: computeMediaConsecucionObjetivos,
    comprad: computeComprad,
    f_rent_vta: computeMediaConsecucionObjetivos,
    // Center Madrid
    center_madrid_yoy: computeCenterMadridYoY,
    center_madrid_ref_promedio: computeCenterMadridRefPromedio,
    center_madrid_surtido: computeCenterMadridSurtido,
    cajas_regalo: computeCajasRegalo,
    // Catalunya
    volumen_catalunya: computeVolumenCatalunya,
    clientes_catalunya: computeClientesCatalunya,
    cilindros_refrescos_vr_catalunya: computeCilindrosRefrescosVrCatalunya,
    clientes_catalunya_rpv: computeClientesCatalunyaRPV,
    ref_promedio_catalunya_rpv: computeRefPromedioCataluntaRPV,
    // Canarias
    canarias_growth_py_percent: computeCanariasGrowthByPercent,
    canarias_clientes_compradores: computeCanariasClientesCompradores,
    compute_cumplimiento: computeCumplimiento,
    inc_clientes: computeClientesIncClientes,
    south_volumen: computeSouthVolumen,
    south_clientes: computeSouthClientes,
    south_dn: computeSouthDn,
    // Madrid
    madrid_result: computeMadridResult,
    cajas_regalo_result: computeCajasRegaloResultFormula,
    madrid_pct_yoy_acum: computeVolumenAcumPct,
    madrid_pct_compradores: computeClientesPct,
    madrid_pct_gda: computeGdaGroupPct,
    // Baleares
    baleares_clientes_increment: computeBalearesClientesIncrement,
    baleares_variable_kpi: computeBalearesVariableKpi,
};
